<template>
  <div class="poi2" ref="dom" :style="getstyle(poidata)">
    {{poidata.name}}
  </div>
</template>

<script>
export default {
  props: ["poidata"],
  methods: {
    getstyle(poidata) {
      let s = (1 - poidata.s) * 4;
      if (s > 3) s = 3;
      if (s < 0.8) s = 0.8;
      return `left:${poidata.left}px;top:${poidata.top}px;transform: translate3d(-50%, -50%, 0) scale(${s});`;
    },
  },
};
</script>

<style lang="scss" scoped>
.poi2 {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  font-size: 0.05rem;
  color: #4de7ff;
  z-index: 999;
  padding: 0.03rem 0.1rem;
  border: 0.02rem solid #4de7ff;
  border-radius: 0.1rem;
  transition: 100ms;
  cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/poi2.vue